import { Injectable } from "@angular/core";
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { default as olarconfig } from '../../assets/olarconfig.json';

@Injectable()
export class EComGoogleAnalytics {
    environment: any;
    constructor(private gtmService: GoogleTagManagerService) {
        this.environment = olarconfig.Environment;
    }

    customEvent(gtmTag) {
        this.environment = olarconfig.Environment;
        console.log(this.environment);
        // push GTM data layer with a custom event
        // const gtmTag = {
        //     event: eventValue,
        //     eventDataKey: eventDataValue
        // };
        if (this.environment === 'Production') {
            this.gtmService.pushTag(gtmTag);
        }
    }
}